<template>
  <router-view></router-view>
</template>

<script>
import {App} from "@capacitor/app";
import {ScreenOrientation} from "@capacitor/screen-orientation";
import {StatusBar} from '@capacitor/status-bar';
import Swals from "@/assets/js/Swals";
import router from "@/router";
export default {

  name: 'App',
  setup() {

    App.addListener('backButton', async () => {

      let url = window.location.href

      if (url.includes('HomePage') || url.includes('W_HomePage')) {
        await Swals.Question('آیا از برنامه خارج می شوید؟', 'خروج از برنامه').then((res) => {
          if (res.isConfirmed) {
            App.exitApp()
          }
        });
      } else if(url.includes('BillOfLadingPage')){
        await router.push({name:'HomePage'})
      }else {
        window.history.back()
      }


    })

    StatusBar.setBackgroundColor({color: '#4353df'})
    ScreenOrientation.lock({orientation: 'OrientationLockType'})

    window.addEventListener('online' , ()=>{
      Swals.Done('اتصال اینترنت شما برقرار شد :)')
    })

    window.addEventListener('offline' , ()=>{
      Swals.Warning('متاسفانه اتصال اینترنت برقرار نیست !')
    })

    return {}
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
